import React from 'react';
import { StyledButton } from './styles';
import { ButtonProps } from './types';
import { ButtonKind, ButtonMode, ButtonSize } from './enums';

const modeToKind: Record<ButtonMode, ButtonKind> = {
  [ButtonMode.Primary]: ButtonKind.Primary,
  [ButtonMode.Secondary]: ButtonKind.Outline,
  [ButtonMode.Tertiary]: ButtonKind.Danger,
  [ButtonMode.Info]: ButtonKind.Soft,
};

const Button: React.FC<ButtonProps> = ({
  mode = ButtonMode.Primary,
  kind: kindProp,
  size = ButtonSize.Big,
  isFullWidth,
  full,
  icon: Icon,
  iconRight: IconRight,
  children,
  ...props
}) => {
  const kind = kindProp ?? modeToKind[mode];
  // Large reads like Big (body text); Small reads as caption.
  const buttonTextVariant = size === ButtonSize.Small ? 'caption' : 'body';

  return (
    <StyledButton
      variant={buttonTextVariant}
      {...{ kind, size, isFullWidth: isFullWidth || full, ...props }}
    >
      {Icon && <Icon />}
      {children}
      {IconRight && <IconRight />}
    </StyledButton>
  );
};

export default Button;
